import { useLocalSearchParams } from 'expo-router';

import { ReplyDraftScreen } from '@/features/reply-drafts';

/**
 * The expert's reply draft as a full-screen modal over the chat, opened by
 * `.draft`. Native only: web opens the same wizard in a modal inside the chat.
 */
export default function ReplyDraftRoute() {
  const { conversationId } = useLocalSearchParams<{ conversationId?: string }>();

  return <ReplyDraftScreen conversationId={conversationId} />;
}
